import { https } from "../http";
import store from "../store";
import {
  setFacilities,
  setLoginFacility,
  setFacilityTypes,
  setLoading,
  setLoadingAddFacility,
  setAllFacilities,
  setAllFacilityTypes,
  setAllDeletedFacilities,
} from "../store/reducers/facility";
import { showError } from "../utils/index";

// GET
const getAllFacilities = async (page, showLoading = true) => {
  try {
    if (showLoading) store.dispatch(setLoading(true));
    let response = await https().get(`/facility/${page}`);

    if (response?.status === 200) {
      store.dispatch(setFacilities(response?.data));
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const getAllLoginFacilities = async (page, showLoading = true) => {
  try {
    if (showLoading) store.dispatch(setLoading(true));
    let response = await https().get(`/ftype/get-fType-public/${page}`);
    if (response?.status === 200) {
      store.dispatch(setLoginFacility(response?.data));
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

// Returns the count of ACTIVE (active:true, not deleted) facilities for the
// current admin. Used by the plan-downgrade guard so it counts only what the
// user can actually deactivate. Returns a number (0 on failure); does NOT touch
// the shared `allFacilities` store, so it is safe to call from any panel.
const getActiveFacilitiesCount = async () => {
  try {
    const response = await https().get(`/facility/active`);
    if (response?.status === 200) {
      const data = response?.data;
      if (Array.isArray(data)) return data.length;
      if (Array.isArray(data?.results)) return data.results.length;
      if (typeof data?.count === "number") return data.count;
    }
    return 0;
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    return 0;
  }
};

const getAllFacilitiesModal = async (endpoint, showLoading = true) => {
  try {
    if (showLoading) store.dispatch(setLoading(true));
    let response = await https().get(`/facility/${endpoint}`);
    if (response?.status === 200) {
      if (endpoint === "withDeleted") {
        store.dispatch(setAllDeletedFacilities(response?.data));
      } else {
        store.dispatch(setAllFacilities(response?.data));
      }
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

// const getAllFacilitiesModal = async ( showLoading = true) => {
//   try {
//     if (showLoading) store.dispatch(setLoading(true));
//     let response = await https().get(`/facility/all`);

//     if (response?.status === 200) {
//       store.dispatch(setAllFacilities(response?.data));
//     }
//   } catch (error) {
//     store.dispatch(setLoading(false));
//     showError(error?.response?.data?.message, error?.response?.status)
//   }
// };

// // get all facilities for note page
// const getAllFacilitiesNotePage = async ( showLoading = true) => {
//   try {
//     if (showLoading) store.dispatch(setLoading(true));
//     let response = await https().get(`/facility/allNotePage`);

//     if (response?.status === 200) {
//       store.dispatch(setAllFacilities(response?.data));
//     }
//   } catch (error) {
//     store.dispatch(setLoading(false));
//     showError(error?.response?.data?.message, error?.response?.status)
//   }
// };

const getFacilityTypes = async (page) => {
  try {
    store.dispatch(setLoading(true));
    let response = await https().get(`/ftype/${page}`);

    if (response?.status === 200) {
      store.dispatch(setFacilityTypes(response?.data));
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const getAllFacilityTypes = async (page) => {
  try {
    store.dispatch(setLoading(true));
    let response = await https().get(`/ftype/all`);

    if (response?.status === 200) {
      store.dispatch(setAllFacilityTypes(response?.data));
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

// POST
const addFacilityType = async (data, callback) => {
  try {
    store.dispatch(setLoadingAddFacility(true));
    let response = await https().post("/ftype", data);

    if (response?.status === 200) {
      getFacilityTypes(1);
      callback?.();
    }
  } catch (error) {
    store.dispatch(setLoadingAddFacility(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const addLoginFacility = async (data, navigate) => {
  try {
    store.dispatch(setLoadingAddFacility(true));
     await https().post("/facility/facility-create-public", data);
    // if (response?.status === 200) {
    //   getAllFacilities();
    // }
    navigate("/selectprice");
  } catch (error) {
    let string = error?.response?.data?.message;
    if (string?.includes("duplicate") && string?.includes("name"))
      showError("Facility with this name already exist");
    store.dispatch(setLoadingAddFacility(false));
    showError(error?.response?.data?.message, error?.response?.message);
  }
};

const addFacility = async (data, navigate) => {
  try {
    store.dispatch(setLoadingAddFacility(true));
    let response = await https().post("/facility", data);
    if (response?.status === 200) {
      getAllFacilities();
      return response?.data;
      // navigate("/selectprice");
    }
  } catch (error) {
    let string = error?.response?.data?.message;
    if (string?.includes("duplicate") && string.includes("name"))
      showError("Facility with this name already exists");
    else showError(error?.response?.data?.message, error?.response?.status);
    store.dispatch(setLoadingAddFacility(false));
  }
};

// PUT
const editFacilityType = async (data, callback) => {
  try {
    store.dispatch(setLoadingAddFacility(true));
    let response = await https().put("/ftype", data);

    if (response?.status === 200) {
      getFacilityTypes();
      callback?.();
    }
  } catch (error) {
    store.dispatch(setLoadingAddFacility(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const editFacility = async (data, showLoading = true) => {
  try {
    store.dispatch(setLoadingAddFacility(true));
    let response = await https().put(`/facility/${data?.id}`, data);
    if (response?.status === 200) {
      getAllFacilities(showLoading);
      getAllFacilitiesModal(showLoading);
    }
    return response;
  } catch (error) {
    store.dispatch(setLoadingAddFacility(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

// DELETE
const removeFacilityType = async (id, callback) => {
  try {
    store.dispatch(setLoadingAddFacility(true));
    let response = await https().delete(`/ftype/${id}`);

    if (response?.status === 200) {
      getFacilityTypes();
      callback?.();
    }
  } catch (error) {
    store.dispatch(setLoadingAddFacility(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const removeFacility = async (data, callback) => {
  try {
    store.dispatch(setLoadingAddFacility(true));

    let response = await https().delete(`/facility/${data?.id}`);

    if (response?.status === 200) {
      getAllFacilities();
      callback?.();
    }
  } catch (error) {
    store.dispatch(setLoadingAddFacility(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

export {
  getAllFacilities,
  getAllLoginFacilities,
  getFacilityTypes,
  addFacilityType,
  addLoginFacility,
  addFacility,
  removeFacility,
  removeFacilityType,
  editFacilityType,
  editFacility,
  getAllFacilitiesModal,
  getActiveFacilitiesCount,
  getAllFacilityTypes,
};
